import { Box, makeStyles } from "@material-ui/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ParcelList from "./ParcelList";
import Signature from "signature_pad";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleSignature } from "../../actions/selfPickupActions";


const useStyles = makeStyles((theme) => ({
    container: {
        overflow: 'scroll',
        marginTop: 20,
        paddingRight: 20,
        width: '100%',
        overflowX: 'hidden'
    },
    parcelListTitle: {
        marginLeft: 20,
        color: '#FBFBFB',
        opacity: 0.7
    },
    signTitle: {
        marginLeft: 20,
        marginTop: 24,
        marginBottom: 24,
        color: '#FBFBFB',
        opacity: 0.7
    },
    buttonStyle: {
        position: 'absolute',
        right: 60,
        bottom: 15, 
        fontSize: 18
    },
    clearStyle: {
        color: 'white',
        textDecoration: 'underline',
        position: 'absolute',
        left: 32,
        bottom: 15,
        fontSize: 18
    },
    confirmStyle: {
        color: '#ff9800',
        textDecoration: 'underline',
        position: 'absolute',
        right: 60,
        bottom: 15,
        fontSize: 18
    }
}))

function PickupConfirmSection() {
    const classes = useStyles();
    const { t } = useTranslation('selfPickup');
    const dispatch = useDispatch();

    const scrollStyle = { height: 'calc(100vh - 222px)' }

    const validOrders = useSelector(state => state.selfPickupReducer.scannedOrders);

    const [resList, setResList] = useState(validOrders)
    const [signaturePad, setSignaturePad] = useState();
    const [savedSignature, setSavedSignature] = useState("");

    const readyPad = () => {
        let wrapper = document.getElementById("signature-pad");
        let canvas = wrapper?.querySelector("canvas");
        canvas.width = window.innerWidth - 60;
        canvas.height = 240;
        canvas.getContext("2d").scale(1, 1);
        let tempSignaturePad = new Signature(canvas, {
            backgroundColor: "#434343",
            penColor: 'white'
        });
        setSignaturePad(tempSignaturePad);
    };

    const handleClear = () => {
        setSavedSignature('');
        signaturePad.clear();
    };

    const handleConfirm = () => {
        setSavedSignature(signaturePad?.toDataURL());
    }

    useEffect(() => {
        readyPad();
    }, []);

    useEffect(() => {
        setResList(validOrders);
    }, [validOrders]);

    useEffect(() => {
        dispatch(handleSignature(savedSignature));
    }, [savedSignature])

    return (
        <Box className={classes.container} style={scrollStyle}>
            <div className={classes.parcelListTitle}>
                {t('parcel_list')}
            </div>
            <div className={classes.boxList}>
                <ParcelList list={resList} />
            </div>
            <div className={classes.signTitle}>
                {t('customer_signature')}
            </div>
            <div id="signature-pad" style={{ position: 'relative' }}>
                <canvas
                    className="signature-canvas"
                    style={{ marginLeft: 20, marginRight: 40 }}
                ></canvas>
                    <span
                        className={classes.clearStyle}
                        onClick={handleClear}
                    >
                        {t('clear')}
                    </span>
                    <span
                        className={classes.confirmStyle}
                        onClick={handleConfirm}
                    >
                        {t('confirm')}
                </span>
            </div>
        </Box>
    )
}

export default PickupConfirmSection;